import { render, staticRenderFns } from "./detial.vue?vue&type=template&id=5a20ee84&scoped=true"
import script from "./detial.vue?vue&type=script&lang=js"
export * from "./detial.vue?vue&type=script&lang=js"
import style0 from "./detial.vue?vue&type=style&index=0&id=5a20ee84&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20ee84",
  null
  
)

export default component.exports